export const ENTITY_INTERACTION = "EntityInteraction"
